import React, { Component } from "react";
import { Row, Col, Card } from "reactstrap";
import Icon from "react-icons-kit";
import { userOutline, phoneOutline, locationOutline, pencil } from "react-icons-kit/typicons";

import "./shippingDetailsCard.scss";

export default class ShippingDetailsCardComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const iconSelectorBasedOnLabelName = (labelName) => {
            switch (labelName) {
                case "FULL NAME":
                    return userOutline;
                case "CONTACT NUMBER":
                    return phoneOutline;
                case "SHIPPING ADDRESS":
                    return locationOutline;
                case "EMAIL":
                    return locationOutline;
                case "Available Points":
                    return null;
                default:
                    return null;
            }
        };
        const { shippingDetails, title, onEdit } = this.props;
        return (
            <div className="shipping-card-container">
                <h1 className="card-title">{title}</h1>
                <Card className="shipping-details-card">
                    {shippingDetails.map((data, i) => {
                        return (
                            <Row className="sd-card-role" key={`${i}_shipping_details_row`}>
                                <Col className="col-1">{!data.hasOwnProperty("points") && <Icon size={20} className="sd-details-icon-style" icon={iconSelectorBasedOnLabelName(data.label)} />}</Col>
                                <Col>
                                    <p className="label">{data.label}</p>
                                    <p className="desc">{data.desc}</p>
                                </Col>
                                {data.points && (
                                    <Col>
                                        <p className="desc">{data.points}pts</p>
                                    </Col>
                                )}
                                <Col className="col-1 edit-col" onClick={() => onEdit(data.label)}>
                                    <Icon icon={pencil} size={20} />
                                </Col>
                            </Row>
                        );
                    })}
                </Card>
            </div>
        );
    }
}
